"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@shared/polyfills");
// app must be imported first so "reporting.dashboards" angular module is setup.
require("./js/public-angular-conf");
// Files included in the webpack bundle.
require("./client-lib");
require("./css-lib");
require("./less-lib");
